/* eslint-disable */
import logger from '@/sc_utils/logger'
// import WechatShareGuide from '@/sc_components/WechatShareGuide';
import Toast from '@/sc_components/Toast'
import { setShareInformation, shareAction, isInHczApp } from '@/sc_utils/share'

// 是否App环境
const isInApp = () => {
	return !!window.sc && window.sc.isSZSMT()
}

// 是否微信环境
const isInWechat = () => {
	return window.wxBridge && window.wxBridge.isInWechat()
}
// 是否微信环境2
function isWeChatBrowser() {
	// 通过正则表达式检测 User Agent 中是否包含 "MicroMessenger" 关键词
	return /micromessenger/i.test(navigator.userAgent)
}

// 是否在QQ环境
const isInQQOrQZ = () => {
	const ua = navigator.userAgent
	return ua.match(/QQ\/([\d\.]+)/) || ua.indexOf("Qzone/") !== -1
}

// 判断设备是否为iPhone X
const isIphoneX = () => {
	 console.log(navigator.userAgent, Number((`${window.screen.height/window.screen.width}`).substr(0,4)) * 100, 'iphoneX')
	if ((/iphone|android/gi.test(navigator.userAgent)) && Number((`${window.screen.height/window.screen.width}`).substr(0,4)) * 100 >= 216) {
		// iphone X(S)
		return true
	}
	return false

}
// 非App、非微信环境，第三方浏览器打开
const isInBrowser = () => {
	return !isInApp() && !isInWechat()
}
// 非App、非微信环境，第三方浏览器打开
const isInBrowser2 = () => {
	return !isInApp() && !isWeChatBrowser()
}

// 是否在小程序环境
const isInMiniProgram = () => {
	const ua = navigator.userAgent
	if (ua.match(/micromessenger/i) && ua.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram') {
		return 'Wechat'
	}
	return false
}

// 获取设备类型
const deviceType = () => {
	const ua = navigator.userAgent
	if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
		return '1'
	} if (/(Android)/i.test(navigator.userAgent)) {
		return '2'
	}
	return '1|2'
}

// 筛选安卓区分鸿蒙
const getAndroid = () => {
	if (/(Android)/i.test(navigator.userAgent) && !/(HarmonyOS)/i.test(navigator.userAgent)) {
		return true
	}
	return false

}


// 设置分享信息
const setShareInfo = (params) => {
	setShareInformation(params)
}

// 调用分享方法
const share = () => {
	shareAction()
}

// 设置分享回调
const setShareActionCallback = (callback) => {
	if (isInWechat()) {
		window.wxBridge.setShareActionCallback(callback)
	}
}

// 获取当前运行环境
const ENV = {
	// 平安云生产环境
	PRD: 'PRD',
	// 平安云预发布环境
	PRE: 'PRE',
	// 平安云测试环境一
	STG: 'STG',
	// 平安云测试环境二
	STG2: 'STG2',
	// 平安云测试环境三
	STG3: 'STG3',
	// 平安云测试环境四
	STG4: 'STG4',
	// 政府机房测试环境
	GOVSTG: 'GOVSTG',
	// 政府机房生产环境
	GOVPRD: 'GOVPRD',
	// 政府机房预发布环境
	GOVPRE: 'GOVPRE',
	// 开发环境
	DEBUG: 'DEBUG'
}
const getRunningEnv = () => {
	// 政务云
	if (window.location.host.indexOf("isz-web-stg.sz.gov.cn") >= 0) {
		return ENV.GOVSTG
	}
	if (window.location.host.indexOf("isz-web-gray.sz.gov.cn") >= 0) {
		return ENV.GOVPRE
	}
	if (window.location.host.indexOf("isz-web.sz.gov.cn") >= 0) {
		return ENV.GOVPRD
	}
	if (window.location.host.indexOf("smt-web-pre.pingan.com.cn") >= 0) {
		return ENV.PRE
	}
	if (window.location.host.indexOf("smt-web.pingan.com.cn") >= 0) {
		return ENV.PRD
	}
	// SZC测试环境
	if (window.location.href.indexOf("202.105.100.30:8100/sz") >= 0) {
		return ENV.STG
	}
	if (window.location.href.indexOf("202.105.100.30:8100/stg2") >= 0) {
		return ENV.STG2
	}
	if (window.location.href.indexOf("202.105.100.30:8100/stg3") >= 0) {
		return ENV.STG3
	}
	if (window.location.href.indexOf("202.105.100.30:8100/stg4") >= 0) {
		return ENV.STG4
	}
	return ENV.DEBUG
}

// STG1测试环境API base url
const API_BASE_URL_STG1 = 'http://202.105.100.30:8200/'
// const API_BASE_URL_STG1 = `https://sg.digitalgd.com.cn/isz/web/stg1/`
// STG2测试环境API base url
// const API_BASE_URL_STG2 = 'http://202.105.100.30:8600/'
const API_BASE_URL_STG2 = 'http://202.105.100.30:8700/'
// STG3测试环境API base url
const API_BASE_URL_STG3 = 'http://202.105.100.30:8700/'
// const API_BASE_URL_STG3 = `http://10.253.196.140/`;
// STG4测试环境API base url
// const API_BASE_URL_STG4 = `${window.location.protocol}//isz-cloud-stg4.yun.city.pingan.com/`;
const API_BASE_URL_STG4 = 'http://202.105.100.30:8700/'
// 政府机房生产环境API base url
const API_BASE_URL_GOV_PRD = `${window.location.protocol}//isz-app.sz.gov.cn/`
// 政府机房预发布环境API base url
const API_BASE_URL_GOV_PRE = `${window.location.protocol}//isz-app-gray.sz.gov.cn/`
// 政府机房测试环境API base url
const API_BASE_URL_GOV_STG = `${window.location.protocol}//isz-app-stg.sz.gov.cn/`

const getApiEnv = () => {
	// 政务云
	if (window.location.host.indexOf("isz-web-stg.sz.gov.cn") >= 0) {
		return API_BASE_URL_GOV_STG
	}
	if (window.location.host.indexOf("isz-web-gray.sz.gov.cn") >= 0) {
		return API_BASE_URL_GOV_PRE
	}
	if (window.location.host.indexOf("isz-web.sz.gov.cn") >= 0) {
		return API_BASE_URL_GOV_PRD
	}
	// SZC测试环境
	if (window.location.href.indexOf("202.105.100.30:8100/sz") >= 0) {
		return API_BASE_URL_STG1
	}
	if (window.location.href.indexOf("202.105.100.30:8100/stg2") >= 0) {
		return API_BASE_URL_STG2
	}
	if (window.location.href.indexOf("202.105.100.30:8100/stg3") >= 0) {
		return API_BASE_URL_STG3
	}
	if (window.location.href.indexOf("202.105.100.30:8100/stg4") >= 0) {
		return API_BASE_URL_STG4
	}
	return API_BASE_URL_STG1
}


/**
* 获取浏览器当前环境
* @returns {string}  app 、 微信、 qq、 其他
*/
const getBrowserEnv = () => {
	let res = '其他'
	if (isInApp()) {
		res = 'app'
	} if (isInWechat()) {
		window.sessionStorage.setItem('isWeiXin',true)
		res = '微信'
	} if (isInQQOrQZ()) {
		res = 'qq'
	}
	return res
}


// 百度统计
function reportData(type, text) {
	if (window._hmt) {
		const VT = getUrlParamValue('vt') || 'h5'
		// 百度统计点击事件
		_hmt.push(['_trackEvent', type, 'click', `${text}--isInApp=${isInApp()}--vt=${VT}`])
	}
}

function setPageTitle(title) {
	// 解决在qq浏览器中，异步修改title时，导航栏中的title没有设置成功
	if (isInQQOrQZ()) {
		const i = document.createElement('iframe')
		i.src = 'https://www.baidu.com/favicon.ico'
		i.style.display = 'none'
		i.onload = () => {
			setTimeout(() => {
				i.remove()
			}, 9)
		}
		document.title = title
		document.body.appendChild(i)
	}
	document.title = title
	if (isInApp()) {
		window.sc.setNavigationBarTitle(title)
	}
}

// 关闭webview回到首页
function closeWithBackHome(tabIndex = 0) {
	if (isInApp()) {
		window.sc.closeWithBackHome(tabIndex, function (result) {
			// 当前版本过低，不支持该Hybrid交互接口
			if (result.code === window.sc.CODE.NOT_SUPPORT) {
				alert(result.message)
			}
		})
	} else {
		alert("非App环境，不支持Hybrid交互接口")
	}
}
/**
 * 此函数迁移至utils.js文件中，请从utils.js文件中引用
 */
function getUrlParamValue(name) {
	const reg = new RegExp(`(^|&)${  name  }=([^&]*)(&|$)`)
	const r = window.location.search.substr(1).match(reg)
	if (r != null)
		return unescape(r[2])
	return null
}

function printRecruitConsoleMessageInPrdEnv() {
	if (getRunningEnv() === ENV.PRD) {
		console.log(`%c平安智慧城市 - 智慧生活前端开发团队`, `color: #006600`)
		console.log(`%c简历投递：gaoyijun258@pingan.com.cn`, `color: #006600`)
	}
}

/**
 * app内部获取用户登录态
 * @param {object} params 传给渠道活动信息,区分注册来源
 * @param {boolean} [params.isEnterprise] 是否为营商通企业用户登录
 * @param {是否需要拉起登录} tokenFetchType
 * @param {回调} callback
 */

const getUserToken = (params = {}, tokenFetchType, callback, cancelCallback) => {
	const TOKEN_FETCH_TYPE = {
		LOGIN_IF_EMPTY: "LOGIN_IF_EMPTY",
		DO_NOTHING_IF_EMPTY: "DO_NOTHING_IF_EMPTY"
	}
	window.sc.getUserInfo(result => {
		logger.debug(`App登陆回调：${JSON.stringify(result)}`)
		if (result.code === window.sc.CODE.SUCCESS) {
			callback && callback(result.data)
		} else if (result.code === window.sc.CODE.FAILED) {
			if (tokenFetchType === TOKEN_FETCH_TYPE.LOGIN_IF_EMPTY) {
				// 未登录，拉起Native登录界面
				window.sc.nativeRoute({
					path: '/user/login/main',
					params: {
						subParams: params,
						isNoToken: false // 需要回传token
					},
					openType: 1
				}, (result) => {
					logger.debug(`App登陆回调：${JSON.stringify(result)}`)
					if (result.code === window.sc.CODE.SUCCESS) {
						callback && callback(result.data)
					} else {
						cancelCallback && cancelCallback()
					}
				})
			}
		} else if (result.code === window.sc.CODE.NOT_SUPPORT) {
			// 当前版本过低，不支持该Hybrid交互接口
			if (tokenFetchType == TOKEN_FETCH_TYPE.LOGIN_IF_EMPTY) {
				alert('当前版本过低')
			}
		}
	})
}

// 获取设备信息

const getDeviceInfo = (callback) => {
	if (isInApp()) {
		window.sc.getDeviceInfo(function (result) {
			if (result.code === window.sc.CODE.SUCCESS) {
				callback && callback(result.data)
			}
		})
	} else {
		alert("非App环境，不支持获取设备信息")
	}
}

/**
 * 调用app实名认证
 * @param {参数, Object} params
 * @param {回调文件类型, String} params.infoType 0：图片 1：无返回 不传：无返回
 * @param {请求流水号, String} params.requestNo 内部使用，开放平台不公开
 * @param {请求额外信息, String} params.requestExtra 内部使用，开放平台不公开
 * @param {认证类型, String} params.authType 0：全部  1：公安人脸 2：省统一小程序 不传或270以下：公安人脸，多个值组合以','分隔
 * @param {成功回调, function} callback
 * @param {取消回调, function} cancelCallback
 */

const requestCertification = (params = {}, callback, cancelCallback) => {
	if (isInApp()) {
		window.sc.nativeRoute({
			path: '/user/auth/verify',
			params: {
				authType: '0',
				...params
			}
		}, (result) => {
			if (result.code === window.sc.CODE.NOT_SUPPORT) {
				alert("版本过低，不支持实名认证功能")
			} else if (result.code === window.sc.CODE.SUCCESS) {
				callback && callback()
			} else {
				logger.debug('[认证失败]')
				cancelCallback && cancelCallback()
			}
		})
	} else {
		alert("非App环境，不支持Hybrid交互接口")
	}
}


// 设置好车主toast提示
const setHczToast = () => {
	if (isInHczApp() && !window.sessionStorage.getItem('hasShow')) {
		Toast.show({
			content: '已离开好车主APP,进入第三方页面',
			duration: 2
		})
		window.sessionStorage.setItem('hasShow', 'true')
	}
}

/**
 * 用hash route path打开新的window窗口
 * @param {string} path
 */
function openNewWebViewWithHashRoute(path) {
	const url = `${window.location.origin + window.location.pathname  }#${  path}`
	if (isInApp() && window.sc.getAppVersion() >= '1.6.0') {
		window.sc.openNewWebView({ url })
	} else {
		window.open(url)
	}
}

// 打开一个新的webiew
function openNewWebView(url) {
	if (isInApp() && window.sc.getAppVersion() >= '1.6.0') {
		window.sc.openNewWebView({ url })
	} else {
		const hasUiparams = url.indexOf('uiparams') !== -1
		window.location.href = (hasUiparams ? encodeURI(decodeURI(url)) :  encodeURI(url))
	}
}

// token失效时拉起登陆页面
const requestLogin = () => {
	window.sc.nativeRoute({
		path: '/user/login/main',
		params: {},
		openType: 1
	}, (result) => {
		if (result.code !== window.sc.CODE.SUCCESS) {
			logger.debug(`[Hybrid]错误：${  result.message}`)
		} else {
			closeWithBackHome()
		}
	})
}

/**
 * 调试插件自动注入
 */
const debugInjectOfRunningEnv = () => {
	// 获取 process.env.API_ENV 环境变量
	const env = getRunningEnv()
	const list = ['DEBUG', 'STG', 'STG2', 'STG3']
	// 判断环境注入
	if (list.indexOf(env) !== -1) {
		const script = document.createElement('script')
		script.src = 'https://cdn.jsdelivr.net/npm/eruda'
		document.body.appendChild(script)
		script.onload = function () {
			// 执行
			window.eruda.init()
		}
	}
}

export {
	isInApp,
	isInWechat,
	isWeChatBrowser,
	isInBrowser,
	isInBrowser2,
	isInQQOrQZ,
	isInMiniProgram,
	deviceType,
	getRunningEnv,
	getApiEnv,
	getBrowserEnv,
	setShareInfo,
	setShareActionCallback,
	share,
	reportData,
	setPageTitle,
	closeWithBackHome,
	getUrlParamValue,
	printRecruitConsoleMessageInPrdEnv,
	getUserToken,
	getDeviceInfo,
	requestCertification,
	setHczToast,
	openNewWebViewWithHashRoute,
	openNewWebView,
	requestLogin,
	isIphoneX,
	debugInjectOfRunningEnv,
	getAndroid
}
